/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

@Directive({
  selector: 'zef-form-hints'
})
export class ZefFormHintsDirective { }
